import moment from 'moment-timezone';
import React from 'react';
import { useLocation } from 'react-router-dom';

import {
  BookingTimeContainer,
  DayContainer,
  TimeOfDayText,
  TimeSlotContainer,
  TimeSlotMessage,
  TimeSlotBubble,
  TimeSlotText,
  CameraIconContainer
} from './DaySection.styled';
import { Camera } from 'assets/icons/Icons';
import { Day, TimeSlot } from 'kb-shared';

import { OrganizedListType } from './DaySection.types';

const getParsedTime = (time: string, timezone: string | undefined) => {
  return timezone ? moment(time).tz(timezone) : moment(time);
};

export const DaySection = (props: {
  day?: Day;
  selectedTimeSlotId: string | null;
  onSelect: (slot: TimeSlot) => void;
  showInTimezone: string | undefined;
}) => {
  const location = useLocation();
  const appointmentTypeToShow = new URLSearchParams(location.search).get('appointment_types');

  const organizedList = {
    Morning: Array<TimeSlot>(),
    Afternoon: Array<TimeSlot>(),
    Evening: Array<TimeSlot>()
  };

  if (props.day && props.day.timeslots) {
    props.day.timeslots.forEach((slot: TimeSlot) => {
      const timeParsed = getParsedTime(slot.startTime, props.showInTimezone);
      const hour = timeParsed.hours();

      if (hour < 12) {
        organizedList['Morning'].push(slot);
      } else if (hour < 17) {
        organizedList['Afternoon'].push(slot);
      } else {
        organizedList['Evening'].push(slot);
      }
    });
  }

  return (
    <BookingTimeContainer>
      {Object.keys(organizedList).map((key: string) => {
        const slotsForTimeOfDay = organizedList[key as keyof OrganizedListType];
        const filteredSlots = slotsForTimeOfDay.filter((slot: TimeSlot) => {
          if (appointmentTypeToShow === 'inClinic' && slot.virtualAppointment) return false;
          if (appointmentTypeToShow === 'virtual' && !slot.virtualAppointment) return false;
          return true;
        });

        return (
          <DayContainer key={key}>
            <TimeOfDayText>{key}</TimeOfDayText>
            <TimeSlotContainer>
              {filteredSlots.length === 0 ? (
                <TimeSlotMessage>There are no available time slots</TimeSlotMessage>
              ) : (
                filteredSlots.map((slot: TimeSlot) => {
                  const selected = slot.id === props.selectedTimeSlotId;

                  return (
                    <TimeSlotBubble
                      key={`${slot.id}-${slot.virtualAppointment ? 'virtual' : 'in-clinic'}`}
                      selected={selected}
                      onClick={() => {
                        props.onSelect(slot);
                      }}
                    >
                      <TimeSlotText selected={selected}>
                        {getParsedTime(slot.startTime, props.showInTimezone).format('h:mm A')}
                      </TimeSlotText>
                      {slot.virtualAppointment && (
                        <CameraIconContainer>
                          <Camera type="solid" width={12} height={12} />
                        </CameraIconContainer>
                      )}
                    </TimeSlotBubble>
                  );
                })
              )}
            </TimeSlotContainer>
          </DayContainer>
        );
      })}
    </BookingTimeContainer>
  );
};
